import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { actions, selectors } from 'shared/store'
import { useUserActions } from 'shared/hooks'
import { config } from 'config'
import moment from 'moment'
import i18n from 'config/i18n'

export const useSelect = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { data: availableLanguages } = useSelector(
    selectors.settings.getLanguages
  )

  const { isLoadingFinished } = useUserActions()

  useEffect(() => {
    if (!isLoadingFinished || !availableLanguages.length) return
    const languageId = availableLanguages.find(
      l => `${l.code}`.toLowerCase() === i18n.language
    )?.id

    if (languageId) {
      dispatch(actions.settings.setLanguage(languageId))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language, isLoadingFinished, availableLanguages])

  useEffect(() => {
    dispatch(actions.settings.getLanguages({ disableRefetch: true }))
    dispatch(actions.settings.getSelectedLanguage({ disableRefetch: true }))
  }, [dispatch])

  const options = Object.keys(i18n.options.resources || {}).map(lng => ({
    title: t(`languages.${lng}`, { lng }),
    value: lng,
  }))

  const onSelect = async (lng: string) => {
    await localStorage.setItem(config.languageKey, lng)
    i18n.changeLanguage(lng)
    moment.locale(lng)
    dispatch(actions.settings.getCountries())
  }

  return {
    current: {
      title: t(`languages.${i18n.language}`, { lng: i18n.language }),
      value: i18n.language,
    },
    options,
    onSelect,
  }
}
